/* AWOL · GALERÍA
   Dos trabajos: hacer derivar las fotos y dejar recorrerlas.

   La vecindad ya no se dibuja, pero se sigue calculando: cada foto conoce
   a sus dos más cercanas en el plano. El visor usa eso para ofrecer las
   salidas en la dirección real en que vive cada una. Moverse por la
   galería sigue siendo recorrer el espacio, no pasar páginas. */
(function () {
  var galerias = document.querySelectorAll('[data-awol-galeria]');
  if (!galerias.length) return;

  var quieto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  galerias.forEach(function (galeria) {
    var plano = galeria.querySelector('[data-awol-plano]');
    var nodos = Array.prototype.slice.call(galeria.querySelectorAll('[data-awol-nodo]'));
    if (!plano || nodos.length < 2) return;

    var pares = [];
    var puntos = [];
    var vecinos = nodos.map(function () { return []; });

    var centro = function (nodo) {
      var c = plano.getBoundingClientRect();
      var r = nodo.getBoundingClientRect();
      return { x: r.left - c.left + r.width / 2, y: r.top - c.top + r.height / 2 };
    };

    var medir = function () {
      puntos = nodos.map(centro);

      /* Cada nodo con sus dos más cercanos, sin repetir el par. La vecindad
         ya no se dibuja; sólo gobierna por dónde se sale en el visor. */
      var vistos = {};
      pares = [];
      vecinos = nodos.map(function () { return []; });

      puntos.forEach(function (p, i) {
        puntos
          .map(function (q, j) { return { j: j, d: Math.hypot(p.x - q.x, p.y - q.y) }; })
          .filter(function (o) { return o.j !== i; })
          .sort(function (a, b) { return a.d - b.d; })
          .slice(0, 2)
          .forEach(function (o) {
            var clave = Math.min(i, o.j) + '-' + Math.max(i, o.j);
            if (vistos[clave]) return;
            vistos[clave] = true;
            pares.push([i, o.j]);
          });
      });

      pares.forEach(function (par) {
        if (vecinos[par[0]].indexOf(par[1]) < 0) vecinos[par[0]].push(par[1]);
        if (vecinos[par[1]].indexOf(par[0]) < 0) vecinos[par[1]].push(par[0]);
      });
    };

    /* La deriva: cada nodo se mueve según su profundidad y la red lo sigue. */
    var pendiente = false;
    var derivar = function (evento) {
      if (quieto || pendiente) return;
      pendiente = true;
      requestAnimationFrame(function () {
        pendiente = false;
        var c = plano.getBoundingClientRect();
        var dx = (evento.clientX - (c.left + c.width / 2)) / c.width;
        var dy = (evento.clientY - (c.top + c.height / 2)) / c.height;
        nodos.forEach(function (nodo) {
          var p = parseFloat(nodo.getAttribute('data-profundidad')) || 0;
          nodo.style.transform =
            'translate(' + (-dx * p).toFixed(2) + 'px, ' + (-dy * p).toFixed(2) + 'px)';
        });
      });
    };

    var soltar = function () {
      nodos.forEach(function (nodo) { nodo.style.transform = ''; });
      setTimeout(medir, 520);
    };

    /* ----------------------------------------------------------------
       EL VISOR
       Abre una foto y ofrece como salidas únicamente sus vecinas, cada
       una colocada en la dirección real en que vive dentro del plano.
       ---------------------------------------------------------------- */

    var visor = document.createElement('div');
    visor.className = 'awol-visor';
    visor.setAttribute('role', 'dialog');
    visor.setAttribute('aria-modal', 'true');
    visor.setAttribute('aria-label', 'Galería');
    visor.hidden = true;
    visor.innerHTML =
      '<div class="awol-visor__barra">' +
        '<span class="awol-visor__folio" data-visor-folio></span>' +
        '<span class="awol-visor__pie" data-visor-pie></span>' +
        '<button type="button" class="awol-visor__cerrar" data-visor-cerrar>Cerrar</button>' +
      '</div>' +
      '<div class="awol-visor__caja">' +
        '<figure class="awol-visor__marco" data-visor-marco></figure>' +
        '<div class="awol-visor__salidas" data-visor-salidas></div>' +
      '</div>' +
      '<svg class="awol-visor__mapa" data-visor-mapa aria-hidden="true"></svg>';
    document.body.appendChild(visor);

    var vFolio = visor.querySelector('[data-visor-folio]');
    var vPie = visor.querySelector('[data-visor-pie]');
    var vMarco = visor.querySelector('[data-visor-marco]');
    var vSalidas = visor.querySelector('[data-visor-salidas]');
    var vMapa = visor.querySelector('[data-visor-mapa]');
    var actual = -1;
    var devolverFoco = null;

    /* El mini mapa: dónde estás parado y de dónde cuelgas. */
    var pintarMapa = function (i) {
      if (!puntos.length) return;
      var xs = puntos.map(function (p) { return p.x; });
      var ys = puntos.map(function (p) { return p.y; });
      var x0 = Math.min.apply(null, xs), x1 = Math.max.apply(null, xs);
      var y0 = Math.min.apply(null, ys), y1 = Math.max.apply(null, ys);
      var ancho = Math.max(x1 - x0, 1), alto = Math.max(y1 - y0, 1);
      var norm = puntos.map(function (p) {
        return { x: 6 + ((p.x - x0) / ancho) * 88, y: 6 + ((p.y - y0) / alto) * 88 };
      });

      var marcas = norm.map(function (p, j) {
        var r = j === i ? 4 : vecinos[i].indexOf(j) >= 0 ? 3 : 2;
        var estado = j === i ? ' data-aqui' : vecinos[i].indexOf(j) >= 0 ? ' data-cerca' : '';
        return '<circle cx="' + p.x + '" cy="' + p.y + '" r="' + r + '"' + estado + '></circle>';
      }).join('');

      vMapa.setAttribute('viewBox', '0 0 100 100');
      vMapa.innerHTML = marcas;
    };

    var salidasActuales = [];

    var pintarSalidas = function (i) {
      salidasActuales = vecinos[i]
        .map(function (j) {
          var a = puntos[i], b = puntos[j];
          return { j: j, ang: Math.atan2(b.y - a.y, b.x - a.x) };
        })
        .sort(function (p, q) { return p.ang - q.ang; });

      vSalidas.innerHTML = salidasActuales
        .map(function (s) {
          var grados = (s.ang * 180) / Math.PI;
          var x = 50 + Math.cos(s.ang) * 44;
          var y = 50 + Math.sin(s.ang) * 44;
          var folio = ('0' + (s.j + 1)).slice(-2);
          return (
            '<button type="button" class="awol-visor__salida" data-ir="' + s.j + '"' +
            ' style="left:' + x.toFixed(1) + '%; top:' + y.toFixed(1) + '%;"' +
            ' aria-label="Ir a la foto ' + folio + '">' +
            '<span class="awol-visor__flecha" style="transform: rotate(' + grados.toFixed(1) + 'deg);">&#8594;</span>' +
            '<span class="awol-visor__destino">' + folio + '</span>' +
            '</button>'
          );
        })
        .join('');

      Array.prototype.forEach.call(vSalidas.querySelectorAll('[data-ir]'), function (b) {
        b.addEventListener('click', function () {
          mostrar(parseInt(b.getAttribute('data-ir'), 10));
        });
      });
    };

    var mostrar = function (i) {
      var nodo = nodos[i];
      if (!nodo) return;
      actual = i;

      var original = nodo.querySelector('img');
      vMarco.innerHTML = '';
      if (original) {
        var copia = original.cloneNode(true);
        copia.className = 'awol-visor__imagen';
        copia.setAttribute('sizes', '90vw');
        copia.removeAttribute('loading');
        vMarco.appendChild(copia);
      }

      var pie = nodo.querySelector('.awol-galeria__pie');
      var folio = nodo.querySelector('.awol-galeria__folio');
      vFolio.textContent = folio ? folio.textContent.trim() : ('0' + (i + 1)).slice(-2);
      var texto = '';
      if (pie) {
        texto = pie.textContent.replace(vFolio.textContent, '').trim();
      }
      vPie.textContent = texto;

      pintarSalidas(i);
      pintarMapa(i);
    };

    var abrir = function (i) {
      devolverFoco = document.activeElement;
      medir();
      visor.hidden = false;
      document.documentElement.classList.add('awol-sin-scroll');
      mostrar(i);
      visor.querySelector('[data-visor-cerrar]').focus({ preventScroll: true });
      document.addEventListener('keydown', alTeclado);
    };

    var cerrar = function () {
      visor.hidden = true;
      document.documentElement.classList.remove('awol-sin-scroll');
      document.removeEventListener('keydown', alTeclado);
      if (devolverFoco && devolverFoco.focus) devolverFoco.focus({ preventScroll: true });
    };

    /* Las flechas del teclado eligen la salida que más apunta hacia allá. */
    var rumbos = {
      ArrowRight: 0,
      ArrowDown: Math.PI / 2,
      ArrowLeft: Math.PI,
      ArrowUp: -Math.PI / 2,
    };

    function alTeclado(evento) {
      if (evento.key === 'Escape') return cerrar();
      if (!(evento.key in rumbos) || !salidasActuales.length) return;
      evento.preventDefault();

      var objetivo = rumbos[evento.key];
      var mejor = null;
      var menor = Infinity;
      salidasActuales.forEach(function (s) {
        var d = Math.abs(Math.atan2(Math.sin(s.ang - objetivo), Math.cos(s.ang - objetivo)));
        if (d < menor) { menor = d; mejor = s; }
      });
      /* Sólo si de verdad va por ese rumbo: nada de saltos a la espalda. */
      if (mejor && menor < Math.PI / 2) mostrar(mejor.j);
    }

    visor.querySelector('[data-visor-cerrar]').addEventListener('click', cerrar);
    visor.addEventListener('click', function (evento) {
      if (evento.target === visor) cerrar();
    });

    nodos.forEach(function (nodo, i) {
      nodo.setAttribute('tabindex', '0');
      nodo.setAttribute('role', 'button');
      nodo.addEventListener('click', function () { abrir(i); });
      nodo.addEventListener('keydown', function (evento) {
        if (evento.key === 'Enter' || evento.key === ' ') {
          evento.preventDefault();
          abrir(i);
        }
      });
    });

    medir();
    window.addEventListener('resize', medir);
    nodos.forEach(function (nodo) {
      var img = nodo.querySelector('img');
      if (img && !img.complete) img.addEventListener('load', medir);
    });

    if (window.matchMedia('(min-width: 750px)').matches) {
      plano.addEventListener('mousemove', derivar);
      plano.addEventListener('mouseleave', soltar);
    }
  });
})();
